import { render } from "./DeleteAccountModal.vue?vue&type=template&id=1cae8e90&scoped=true"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=js"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=js"

import "./DeleteAccountModal.vue?vue&type=style&index=0&id=1cae8e90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cae8e90"]])

export default __exports__